export enum Visibility {
  Internal = 1,
  Customer = 2,
}
